import React,{useEffect,useState} from 'react'
import Axios from 'axios'
import Slot from '../Slot'
import moment from 'moment';
import {makeStyles } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.min.css';
import Tradecodes from '../Tradecodes'
import { Spinner } from 'react-bootstrap';
import { Grid } from '@mui/material';
import { Dropdown } from 'semantic-ui-react'
import { ButtonContent, Placeholder, Search, Icon} from "semantic-ui-react";
import { IReq } from '../../../../app/models/req';

import config from '../../../../app/api/apiconfig';

const baseURL = config.app.baseUrl
const schedulingbaseUrl = config.app.schedulingbaseUrl


//TEST TEST TEST againd d
const useStyles = makeStyles((theme) => ({   
    Container: {
        margin: "0 auto"
    },
    Spinner: {
        position: "fixed",
        top: "50%",
        left: "50%",
    },
    Dropdown: {
        paddingBottom: "10px",
        backgroundColor: "red"
    },
    H2:{
        textAlign: "center",
        margin:"0 auto",
        width: "100%"
    },
    Tradecode: {
        marginBottom: "15px",
        marginTop: "15px"

    },
    SearchContainer: {
        width: "100%",
        display:"flex"
    },
    SearchIcon: {
        paddingTop: "5px"
    }


}));


export default function AvailabilityDash(props) {
    
    const classes = useStyles();
    const [resourcedata,setresourceData] = useState([]);
    const [loading,setLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [jobData,setJobData] = useState([]);

    function handleSearch(event){
        let value = event.target.value.toLowerCase();
        setQuery(value);
    }

    function getAvailability(res,tradecode){
        const request = {
            ClientID: "LA01", Duration: 60, Priority: "Routine", ReturnedSlots: 100, TradeCode: tradecode, DateRaised: res.DateRaised, PostCode: res.PostCode, TargetDate: res.TargetDate, WorkorderId: res.workorderId
        }
        let getavailurl = schedulingbaseUrl + "getAvailability" 
        var JsonRequest = request

        //Axios.post("https://lookaheadintegrationapi.azurewebsites.net/api/Scheduling/getAvailability",JsonRequest)
        Axios.post(getavailurl,JsonRequest)
            .then(response => {
                console.log(response.data)
                ///CHANGE 0714 - to sorting availability slot
                const respAsc = [...response.data].sort((a, b) =>
                    a.Start > b.Start ? 1 : -1,
                );
                console.log(respAsc);
                setresourceData(respAsc)
                setLoading(false)
        })


    }

    function findJobByJobNumber(jobNumber,tradecode) {
        
        let posturl = baseURL + "cp/workorders/getJobByNumber?jobNumber=" + jobNumber
        //Axios.post("https://gilm-clientportal-test.azurewebsites.net/cp/workorders/getJobByNumber?jobNumber=" + jobNumber)
        Axios.post(posturl)
        .then(response => {
            setJobData(response.data)
           getAvailability(response.data,tradecode)
        })
    }
   
    function getData(tradecode){
        try
        {
            findJobByJobNumber(props.match.params.JobNumber,tradecode)
         
        }
        catch(ex){
            console.error("An error has occurred: " + ex)
        }
        
    }

    const handleSelect=async (event,data)=>{
        const tradecode = data.value;
        setLoading(true) // needed for dynamics event
        getData(tradecode)
      }



    return (
    <div className={classes.Container}>
        <h2 className={classes.H2}>Showing Availability Slots for {props.match.params.JobNumber}</h2>
       
        <Dropdown
            className={classes.Tradecode}
            placeholder='Select a Tradecode'
            fluid
            search
            selection
            onChange={handleSelect}
            options={Tradecodes}
        />
          
        <Grid 
            container 
            spacing={2}
            alignItems="center"
            columns={{ xs: 6, sm: 6, md: 6, xl: 6 }}
            >
            {
            
                loading ? <Spinner className={classes.Spinner} animation="border" /> 
                
                : resourcedata.map((item, i) =>(

                <Grid item xs={2} sm={2} md={2} xl={2} key={i}>
                    <Slot 
                        jobdata={jobData}
                        resourcedata={resourcedata[i]}
                        startTime={item['Start']}
                        endTime={item['End']}
                    />
                </Grid>

                

            ))
        }
            
            
            
        </Grid>
        
    </div>
 )}

